export const soapDetailRootSx = {
  width: '100%',
  height: 'calc(100vh - 130px)',
  minHeight: 0
};

export const soapDetailPaperSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  border: '1px solid #DCDCDC',
  borderRadius: '10px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
  bgcolor: '#FFFFFF'
};

export const soapMetaWrapperSx = {
  flexShrink: 0
};

export const soapDetailGridSx = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden'
};

export const soapDetailGridItemSx = {
  height: '100%',
  minHeight: 0,
  display: 'flex',
  overflow: 'hidden'
};

export const soapDetailColumnSx = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  overflow: 'hidden'
};